export default __webpack_public_path__ + "static/pdp-seller-avatar-124c0132b982090913081a1f2d551935.png";